import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../Shared/Loading'
import ActivityTypeSelect from '../Shared/ActivityTypeSelect'
import FieldOfActivitySelect from '../Shared/FieldOfActivitySelect'
import RequestedProductsSelect from '../Shared/RequestedProductsSelect'
import ActivityPlaceTypeSelect from '../Shared/ActivityPlaceTypeSelect'
import { sellerFormsService } from '../../_services/sellerForms.service'
import { NumberInput } from 'react-hichestan-numberinput'
import PicUploader3 from '../Shared/PicUploader3'
import ProvinceSelect from '../Shared/ProvinceSelect'
import CitySelect from '../Shared/CitySelect'
import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'
// import ReCAPTCHA from 'react-google-recaptcha'
import ClientCaptcha from 'react-client-captcha'
import refreshSvg from '../../assets/images/refresh.svg'
import SweetAlert from 'react-bootstrap-sweetalert'
import Checkbox from '../Shared/Checkbox'
import NumberFormat from 'react-number-format'
import ParsiMap from './ParsiMap'

import { Formik, Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../Shared/ErrorPopUp'
import * as Yup from 'yup'
import logow from '../../assets/images/logow.png'
import { Button, Tab } from 'semantic-ui-react'
import logo from '../../assets/images/logo.png'

import { BiLeftArrowAlt } from "react-icons/bi";

const initData = {
  name: '',
  firstName: '',
  lastName: '',
  nationalCode: '',
  position: '',
  mobile: '09',
  hasTelegram: false,
  hasWhatsapp: false,
  mobile2: '',
  hasTelegram2: false,
  hasWhatsapp2: false,
  tel: '',
  email: '',
  website: '',
  area: '',
  experience: '',

  installationPlaceType: '',
  installationDate: '',
  provinceId: '',
  cityId: '',
  address: '',

  monthlySalesAmount: '',
  previousBrands: '',
  description: '',

  activityType: [],
  requestedProducts: [],
  activityPlaceType: [],
  fieldOfActivity: [],
  fieldOfActivityOther: '',

  pic1: '',
  pic2: '',
  pic3: '',
  pic4: '',

  latitude: '',
  longitude: '',

  captcha: ''
}
const initData2 = {
  input: '',
  mobile2: '',
  captcha2: false
}

class SellerForm extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,
      showSweetAlert: false,
      sellerFormCode: '',
      data: initData,
      data2: initData2,
      inquiryResult: [],
      captchaCode: undefined
    }
  }

  handleSubmit = (values, setSubmitting, resetForm) => {
    if (this.state.captchaCode.toLowerCase() !== values.captcha.toLowerCase()) {
      toastr.warning('عبارت امنیتی وارد شده صحیح نیست')
      document.getElementById('retryButton').click()
    } else {
      this.setState({ loading: true })

      values['activityType'] = values.activityType.toString()
      values['fieldOfActivity'] = values.fieldOfActivity.toString()
      values['requestedProducts'] = values.requestedProducts.toString()
      values['activityPlaceType'] = values.activityPlaceType.toString()

      // console.log(values);
      // console.log(JSON.stringify(values));

      sellerFormsService
        .add(JSON.stringify(values))
        .then(res => {
          let result = res.data
          // console.log(result);

          if (result === -1) {
            toastr.warning(
              'شما یک فرم درخواست نمایندگی تایید نشده دارید و نمی توانید درخواست دیگری ثبت کنید'
            )

            setSubmitting(false)

            resetForm()
          } else {
            this.setState({
              loading: false,
              data: initData,
              sellerFormCode: res.data,
              showSweetAlert: true
            })
            // toastr.success(values.fullName + 'عزیز، گارانتی شما با موفقیت ثبت شد');

            setSubmitting(false)

            resetForm()
          }

          this.setState({ loading: false })

          // history.push("/admin/shops")
        })
        .catch(error => {
          console.log(error)
          this.setState({ loading: false })
          setSubmitting(false)
        })
    }
  }

  handleSubmit2 = (values, setSubmitting) => {
    this.setState({ loading: true })

    var dto = {
      input: values.input,
      mobile: values.mobile2
    }

    console.log(dto)

    sellerFormsService
      .inquiry(dto)
      .then(res => {
        let result = res.data
        console.log(result)

        if (result.length === 0) {
          toastr.warning('اطلاعات وارد شده در سیستم موجود نیست')

          this.setState({ loading: false })

          setSubmitting(false)
        } else {
          this.setState({ loading: false, inquiryResult: result })
          // toastr.success(values.fullName + 'عزیز، گارانتی شما با موفقیت ثبت شد');

          setSubmitting(false)
        }

        this.setState({ loading: false })

        // history.push("/admin/shops")
      })
      .catch(error => {
        console.log(error)
        this.setState({ loading: false })
        setSubmitting(false)
      })
  }

  // checkCodeMeli = (code) => {

  //   if (code) {
  //     var L = code.length;

  //     if (L < 8 || parseInt(code, 10) == 0) return false;
  //     code = ('0000' + code).substr(L + 4 - 10);
  //     if (parseInt(code.substr(3, 6), 10) == 0) return false;
  //     var c = parseInt(code.substr(9, 1), 10);
  //     var s = 0;
  //     for (var i = 0; i < 9; i++)
  //       s += parseInt(code.substr(i, 1), 10) * (10 - i);
  //     s = s % 11;
  //     return (s < 2 && c == s) || (s >= 2 && c == (11 - s));
  //     return true;
  //   } else {
  //     return false
  //   }

  // }

  checkCodeMeli = code => {
    if (code) {
      if (!/^\d{10}$/.test(code)) return false

      if (/^(\d)\1+$/.test(code)) return false

      var check = +code[9]
      var sum =
        Array(9)
          .fill()
          .map((_, i) => +code[i] * (10 - i))
          .reduce((x, y) => x + y) % 11
      return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11)
    } else {
      return false
    }
  }

  onCaptchaKeyDown = event => {
    if (event.keyCode === 13) {
      event.preventDefault()
      // formEl.current.dispatchEvent(new Event('submit', { cancelable: true }))
    }
  }

  render() {
    const { data, data2, loading, inquiryResult } = this.state
    const ValidationSchema = Yup.object().shape({
      name: Yup.string()
        .trim()
        .nullable()
        .required('نام فروشگاه'),
      firstName: Yup.string()
        .trim()
        .nullable()
        .required('نام'),
      lastName: Yup.string()
        .trim()
        .nullable()
        .required('نام خانوادگی'),
      nationalCode: Yup.string()
        .min(10, 'کد ملی معتبر')
        .test('checkCodeMeli', 'کد ملی معتبر', value =>
          this.checkCodeMeli(value)
        )
        .required('کد ملی'),

      mobile: Yup.string()
        .trim()
        .nullable()
        .required('وارد کردن [شماره موبایل] الزامی است')
        .matches(/(\+98|0)?9\d{9}/, {
          message: 'شماره موبایل وارد شده نامعتبر است',
          excludeEmptyString: false
        }),

      position: Yup.string()
        .trim()
        .nullable()
        .required('سمت'),
      tel: Yup.string()
        .trim()
        .nullable()
        .required('تلفن'),
      provinceId: Yup.string()
        .trim()
        .nullable()
        .required('استان'),
      cityId: Yup.string()
        .trim()
        .nullable()
        .required('شهر'),
      address: Yup.string().required('آدرس'),
      area: Yup.string().required('مساحت حدودی فروشگاه'),
      latitude: Yup.string().required('مختصات فروشگاه'),
      longitude: Yup.string().required('مختصات فروشگاه'),

      activityType: Yup.array()
        .nullable()
        .min(1, 'نوع فعالیت')
        .required('نوع فعالیت'),
      previousBrands: Yup.string().required('برندها'),
      monthlySalesAmount: Yup.string().required('مقدار فروش ماهیانه'),
      requestedProducts: Yup.array()
        .nullable()
        .min(1, 'محصولات و خدمات درخواستی')
        .required('محصولات و خدمات درخواستی'),
      activityPlaceType: Yup.string()
        .trim()
        .nullable()
        .required('نوع محل فعالیت'),
      fieldOfActivity: Yup.array()
        .nullable()
        .min(1, 'زمینه فعالیت')
        .required('زمینه فعالیت'),
      fieldOfActivityOther: Yup.string()
        .nullable()
        .when('fieldOfActivityIsOther', {
          is: true,
          then: Yup.string()
            .trim()
            .nullable()
            .required('سایر فعالیت ها')
        }),

      pic1: Yup.string().required('تصویر کارت ویزیت'),
      pic2: Yup.string().required('تصویر پروانه کسب'),
      pic3: Yup.string().required('تصویر داخل فروشگاه'),
      // pic4: Yup.string().required('تصویر بیرون فروشگاه'),

      captcha: Yup.string()
        .trim()
        .nullable()
        .required('عبارت امنیتی')
      // captcha: Yup.boolean().oneOf([true], 'لطفا عبارت امنیتی را تایید نمائید')
    })
    // const ValidationSchema2 = Yup.object().shape({

    //   input: Yup.string().trim().nullable().required('وارد کردن [کد ملی / کد پیگیری گارانتی] الزامی است')
    //     .length(10, "کد ملی / کد پیگیری گارانتی باید شامل 10 رقم باشد", val => val.toString().length === 10),

    //   mobile2: Yup.string().trim().nullable().required('وارد کردن [شماره موبایل] الزامی است')
    //     .matches(/(\+98|0)?9\d{9}/, { message: "شماره موبایل وارد شده نامعتبر است", excludeEmptyString: false }),

    //   captcha2: Yup.boolean()
    //     .oneOf([true], 'لطفا عبارت امنیتی را تایید نمائید'),

    // });
    return (
      <div>

        <div className="innerpage-head pagetop-bg" dir="rtl">
          <div className="innerpage-head-conteiner">
            <div className="innerpage-head-texts">
              <p className="innerpage-head-title">فرم درخواست نمایندگی</p>
              <div className="innerpage-head-direction">
                <a href="https://mosayyebi.com/">خانه</a>
                <BiLeftArrowAlt />
                <p>فرم درخواست نمایندگی</p>
              </div>
            </div>
            <img src={logo} alt="" />
          </div>

        </div>

        <div className="container">
          <div className="row">
            <div className="col-lg-10 col-lg-offset-1 col-md-12 col-sm-12 col-xs-12">
              {/* <div className="header-row">
                <div>
                  <h4>
                    <strong>گروه صنعتی مصیبی</strong>
                  </h4>
                  <h4 style={{ marginTop: 0 }}>
                    <small>فرم درخواست نمایندگی</small>
                  </h4>
                </div>
                <img src={logo} alt="" />
              </div> */}
              {/* <Tab
              menu={{ secondary: true, pointing: true }}
              panes={[
                { 
                  menuItem: 'فرم درخواست نمایندگی',
                  render: () => */}
              <Tab.Pane>
                <Formik
                  enableReinitialize
                  initialValues={data}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    this.handleSubmit(values, setSubmitting, resetForm)
                  }}
                  validationSchema={ValidationSchema}>
                  {props => {
                    const {
                      values,
                      touched,
                      errors,
                      setFieldValue,
                      setFieldTouched,
                      isSubmitting,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      validateForm
                    } = props
                    return (
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="form-inline">
                            <fieldset className="fieldset fade-in">
                              {/* <legend>اطلاعات فروشگاه</legend> */}

                              <div className="row">
                                <div className="col-lg-4 col-sm-12">
                                  <label>نام</label>
                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue('firstName', e.target.value)
                                    }}
                                    name="firstName"
                                    className={
                                      getIn(touched, 'firstName')
                                        ? getIn(errors, 'firstName')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="firstName"
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <label>نام خانوادگی</label>
                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue('lastName', e.target.value)
                                    }}
                                    name="lastName"
                                    className={
                                      getIn(touched, 'lastName')
                                        ? getIn(errors, 'lastName')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="lastName"
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <label>کد ملی</label>
                                  <NumberInput
                                    maxLength={10}
                                    value={values.nationalCode}
                                    onChange={e => {
                                      setFieldValue(
                                        'nationalCode',
                                        e.target.value
                                      )
                                    }}
                                    className={
                                      getIn(touched, 'nationalCode')
                                        ? getIn(errors, 'nationalCode')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="nationalCode"
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <label>نام فروشگاه</label>
                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue('name', e.target.value)
                                    }}
                                    name="name"
                                    className={
                                      getIn(touched, 'name')
                                        ? getIn(errors, 'name')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="name"
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <label>سمت</label>
                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue('position', e.target.value)
                                    }}
                                    name="position"
                                    className={
                                      getIn(touched, 'position')
                                        ? getIn(errors, 'position')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="position"
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <label>تلفن (با کد شهرستان وارد کنید)</label>
                                  <NumberFormat
                                    format="### ########"
                                    allowEmptyFormatting
                                    mask="_"
                                    disabled={isSubmitting}
                                    value={props.values.tel}
                                    className={
                                      errors.tel
                                        ? 'text-input ltr has-error'
                                        : 'text-input ltr'
                                    }
                                    onChange={e => {
                                      setFieldValue(
                                        'tel',
                                        e.target.value.replace(/\s+/g, '')
                                      )
                                    }}
                                  />
                                  {/* <input
                                        type="text"
                                        maxLength={11}
                                        value={values.tel}
                                        onKeyDown={async (e) => {
                                          if (parseInt(e.target.selectionStart, 0) < 2) {
                                            e.target.setSelectionRange(1, 1);
                                          }
                                        }}
                                        onClick={e => {
                                          if (e.target.selectionStart < 2) {
                                            e.target.focus();
                                            e.target.setSelectionRange(1, 1);
                                          }
                                        }}
                                        onChange={e => {
                                          if (e.target.value.match("^[0-9]*$") != null) {
                                            if (e.target.value.length > 1 && e.target.value.startsWith("0")) {
                                              setFieldValue("tel", e.target.value)
                                            } else {
                                              setFieldValue("tel", "0")
                                              e.target.value = "0";
                                              e.target.focus();
                                              e.target.setSelectionRange(1, 1);
                                            }
                                          }
                                        }}
                                        className="text-input ltr"
                                      /> */}
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="tel"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-6 col-sm-12">
                                  <label>موبایل</label>
                                  <NumberInput
                                    type="tel"
                                    maxLength={11}
                                    value={values.mobile}
                                    onChange={e => {
                                      setFieldValue('mobile', e.target.value)
                                    }}
                                    className={
                                      getIn(touched, 'mobile')
                                        ? getIn(errors, 'mobile')
                                          ? 'text-input ltr has-error'
                                          : 'text-input ltr'
                                        : 'text-input ltr has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="mobile"
                                  />
                                </div>

                                <div className="col-lg-3 col-sm-12 ltr text-left">
                                  <Checkbox
                                    title="Whatsapp"
                                    className="material-ui-checkbox mt-30 ml-5"
                                    onChange={() => {
                                      setFieldValue(
                                        'hasWhatsapp',
                                        !values.hasWhatsapp
                                      )
                                    }}
                                    checked={
                                      values !== undefined && values.hasWhatsapp
                                    }
                                  />
                                </div>

                                <div className="col-lg-3 col-sm-12 ltr text-left">
                                  <Checkbox
                                    title="Telegram"
                                    className="material-ui-checkbox mt-30 ml-5"
                                    onChange={() => {
                                      setFieldValue(
                                        'hasTelegram',
                                        !values.hasTelegram
                                      )
                                    }}
                                    checked={
                                      values !== undefined && values.hasTelegram
                                    }
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-6 col-sm-12">
                                  <label>موبایل</label>
                                  <NumberInput
                                    type="tel"
                                    maxLength={11}
                                    value={values.mobile2}
                                    onChange={e => {
                                      setFieldValue('mobile2', e.target.value)
                                    }}
                                    className={
                                      getIn(touched, 'mobile2')
                                        ? getIn(errors, 'mobile2')
                                          ? 'text-input ltr has-error'
                                          : 'text-input ltr'
                                        : 'text-input ltr has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="mobile2"
                                  />
                                </div>

                                <div className="col-lg-3 col-sm-12 ltr text-left">
                                  <Checkbox
                                    title="Whatsapp"
                                    className="material-ui-checkbox mt-30 ml-5"
                                    onChange={() => {
                                      setFieldValue(
                                        'hasWhatsapp2',
                                        !values.hasWhatsapp2
                                      )
                                    }}
                                    checked={
                                      values !== undefined && values.hasWhatsapp2
                                    }
                                  />
                                </div>

                                <div className="col-lg-3 col-sm-12 ltr text-left">
                                  <Checkbox
                                    title="Telegram"
                                    className="material-ui-checkbox mt-30 ml-5"
                                    onChange={() => {
                                      setFieldValue(
                                        'hasTelegram2',
                                        !values.hasTelegram2
                                      )
                                    }}
                                    checked={
                                      values !== undefined && values.hasTelegram2
                                    }
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-6 col-sm-12">
                                  <label className="rtl">استان</label>
                                  <ProvinceSelect
                                    required
                                    defaultValue={values.provinceId}
                                    onChange={val => {
                                      setFieldValue('provinceId', val.value)
                                      setFieldValue('cityId', '')
                                    }}
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="provinceId"
                                  />
                                </div>

                                <div className="col-lg-6 col-sm-12">
                                  <label className="rtl">شهر</label>
                                  <CitySelect
                                    required
                                    defaultValue={values.cityId}
                                    provinceId={values.provinceId}
                                    onChange={val => {
                                      setFieldValue('cityId', val.value)
                                    }}
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="cityId"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-12 col-sm-12">
                                  <label>آدرس</label>
                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue('address', e.target.value)
                                    }}
                                    name="address"
                                    className={
                                      getIn(touched, 'address')
                                        ? getIn(errors, 'address')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="address"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-6 col-sm-12">
                                  <label>ایمیل</label>
                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue('email', e.target.value)
                                    }}
                                    name="email"
                                    className={
                                      getIn(touched, 'email')
                                        ? getIn(errors, 'email')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="email"
                                  />
                                </div>

                                <div className="col-lg-6 col-sm-12">
                                  <label>وب سایت</label>
                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue('website', e.target.value)
                                    }}
                                    name="website"
                                    className={
                                      getIn(touched, 'website')
                                        ? getIn(errors, 'website')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="website"
                                  />
                                </div>
                              </div>
                            </fieldset>

                            <fieldset className="fieldset fade-in">
                              {/* <legend>اطلاعات محل نصب</legend> */}

                              <div className="row">
                                <div className="col-lg-12 col-sm-12">
                                  <label>نوع فعالیت:</label>
                                  <div
                                    className={
                                      getIn(errors, 'activityType')
                                        ? 'requiredDiv required'
                                        : 'requiredDiv'
                                    }>
                                    <ActivityTypeSelect
                                      onChange={val => {
                                        console.log(val)
                                        setFieldValue('activityType', val)
                                      }}
                                      value={values.activityType}
                                    />
                                  </div>
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="activityType"
                                    type="select"
                                    className="RadioSelectValidator"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-12 col-sm-12">
                                  <label>زمینه فعالیت:</label>
                                  <div
                                    className={
                                      getIn(errors, 'fieldOfActivity')
                                        ? 'requiredDiv required'
                                        : 'requiredDiv'
                                    }>
                                    <FieldOfActivitySelect
                                      onChange={val => {
                                        console.log(val)
                                        setFieldValue('fieldOfActivity', val)
                                        if (val.includes(1)) {
                                          setFieldValue(
                                            'fieldOfActivityIsOther',
                                            true
                                          )
                                        } else {
                                          setFieldValue(
                                            'fieldOfActivityIsOther',
                                            false
                                          )
                                        }
                                      }}
                                      value={values.fieldOfActivity}
                                      values={values}
                                      errors={errors}
                                      setFieldValue={setFieldValue}
                                    />
                                  </div>
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="fieldOfActivity"
                                    type="select"
                                    className="RadioSelectValidator"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-12 col-sm-12">
                                  <label>
                                    با کدام برندهای پارکت قبلا همکاری داشته اید؟
                                  </label>
                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue(
                                        'previousBrands',
                                        e.target.value
                                      )
                                    }}
                                    name="previousBrands"
                                    className={
                                      getIn(touched, 'previousBrands')
                                        ? getIn(errors, 'previousBrands')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="previousBrands"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-4 col-sm-12">
                                  <label>مقدار فروش ماهیانه (متر)</label>
                                  <NumberInput
                                    maxLength={6}
                                    value={values.monthlySalesAmount}
                                    onChange={e => {
                                      setFieldValue(
                                        'monthlySalesAmount',
                                        e.target.value
                                      )
                                    }}
                                    className={
                                      getIn(touched, 'monthlySalesAmount')
                                        ? getIn(errors, 'monthlySalesAmount')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="monthlySalesAmount"
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <label>مساحت حدودی فروشگاه</label>
                                  <NumberInput
                                    maxLength={6}
                                    value={values.area}
                                    onChange={e => {
                                      setFieldValue('area', e.target.value)
                                    }}
                                    className={
                                      getIn(touched, 'area')
                                        ? getIn(errors, 'area')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="area"
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <label>سابقه فعالیت (سال)</label>
                                  <NumberInput
                                    maxLength={6}
                                    value={values.experience}
                                    onChange={e => {
                                      setFieldValue('experience', e.target.value)
                                    }}
                                    className={
                                      getIn(touched, 'experience')
                                        ? getIn(errors, 'experience')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="experience"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-12 col-sm-12">
                                  <label>محصولات و خدمات درخواستی:</label>
                                  <div
                                    className={
                                      getIn(errors, 'requestedProducts')
                                        ? 'requiredDiv required'
                                        : 'requiredDiv'
                                    }>
                                    <RequestedProductsSelect
                                      onChange={val => {
                                        console.log(val)
                                        setFieldValue('requestedProducts', val)
                                      }}
                                      value={values.requestedProducts}
                                    />
                                  </div>
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="requestedProducts"
                                    type="select"
                                    className="RadioSelectValidator"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-12 col-sm-12">
                                  <label>نوع محل فعالیت:</label>
                                  <div
                                    className={
                                      getIn(errors, 'activityPlaceType')
                                        ? 'requiredDiv required'
                                        : 'requiredDiv'
                                    }>
                                    <ActivityPlaceTypeSelect
                                      onChange={val => {
                                        console.log(val)
                                        setFieldValue('activityPlaceType', val)
                                      }}
                                      value={values.activityPlaceType}
                                    />
                                  </div>
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="activityPlaceType"
                                    type="select"
                                    className="RadioSelectValidator"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-lg-12 col-sm-12">
                                  <label>توضیحات</label>
                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue('description', e.target.value)
                                    }}
                                    name="description"
                                    className={
                                      getIn(touched, 'description')
                                        ? getIn(errors, 'description')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                        : 'text-input has-error'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="description"
                                  />
                                </div>
                              </div>
                            </fieldset>

                            <fieldset className="fieldset fade-in">
                              <legend>آپلود تصاویر</legend>

                              <div className="row">
                                <div className="col-lg-4 col-sm-12">
                                  <PicUploader3
                                    value={values.pic1}
                                    onChange={val => {
                                      console.log(val)
                                      setFieldValue('pic1', val)
                                    }}
                                    label="کارت ویزیت"
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="pic1"
                                    style={{
                                      top: -27,
                                      right: 15,
                                      textAlign: 'center'
                                    }}
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <PicUploader3
                                    value={values.pic2}
                                    onChange={val => {
                                      console.log(val)
                                      setFieldValue('pic2', val)
                                    }}
                                    label="پروانه کسب"
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="pic2"
                                    style={{
                                      top: -27,
                                      right: 15,
                                      textAlign: 'center'
                                    }}
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <PicUploader3
                                    value={values.pic3}
                                    onChange={val => {
                                      console.log(val)
                                      setFieldValue('pic3', val)
                                    }}
                                    label="تصویر فروشگاه (داخل)"
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="pic3"
                                    style={{
                                      top: -27,
                                      right: 15,
                                      textAlign: 'center'
                                    }}
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <PicUploader3
                                    value={values.pic4}
                                    onChange={val => {
                                      console.log(val)
                                      setFieldValue('pic4', val)
                                    }}
                                    label="تصویر فروشگاه (بیرون)"
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="pic4"
                                    style={{
                                      top: -27,
                                      right: 15,
                                      textAlign: 'center'
                                    }}
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <PicUploader3
                                    value={values.pic5}
                                    onChange={val => {
                                      console.log(val)
                                      setFieldValue('pic5', val)
                                    }}
                                    label="تصویر دلخواه"
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="pic5"
                                    style={{
                                      top: -27,
                                      right: 15,
                                      textAlign: 'center'
                                    }}
                                  />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                  <PicUploader3
                                    value={values.pic6}
                                    onChange={val => {
                                      console.log(val)
                                      setFieldValue('pic6', val)
                                    }}
                                    label="تصویر دلخواه"
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="pic6"
                                    style={{
                                      top: -27,
                                      right: 15,
                                      textAlign: 'center'
                                    }}
                                  />
                                </div>
                              </div>
                            </fieldset>

                            <fieldset
                              className="fieldset fade-in"
                              style={{ position: 'relative' }}>
                              <legend>مختصات فروشگاه</legend>
                              <ParsiMap
                                onChange={(lat, lng) => {
                                  setFieldValue('latitude', lat)
                                  setFieldValue('longitude', lng)
                                }}
                              />
                              {errors.latitude ? (
                                <div
                                  className={'required_validator visible'}
                                  style={{ top: 9 }}>
                                  <div className="validator_container">
                                    <span>{errors.latitude}</span>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </fieldset>
                          </div>
                        </div>

                        <div className="row">
                          {/* <div className="col-md-5 captcha text-center">
                          <ReCAPTCHA
                            // ref={recaptchaRef}
                            // sitekey="6LdAR7IUAAAAAPPz8y3B9OKFenQV81XiVAOBixgx"
                            sitekey="6LdsYNUUAAAAAH5ZMDQRkuxg7bZ4NodFb-ViZnHl"
                            onChange={() => {
                              setFieldValue('captcha', true)
                            }}
                          />
                          {getIn(errors, 'captcha') &&
                          getIn(touched, 'captcha') ? (
                            <div className={'required_validator visible'}>
                              <div className="validator_container">
                                <span>{errors.captcha}</span>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div> */}

                          <div className="col-md-5">
                            <label htmlFor="captcha">عبارت امنیتی : </label>
                            <div className="captcha-container">
                              <input
                                type="text"
                                className={
                                  errors.captcha
                                    ? 'text-input ltr text-center is-invalid'
                                    : 'text-input ltr text-center'
                                }
                                id="captcha"
                                name="captcha"
                                onKeyDown={e => this.onCaptchaKeyDown(e)}
                                onChange={e =>
                                  setFieldValue('captcha', e.target.value)
                                }
                              // ref={register({
                              //   required: true
                              // })}
                              />

                              <ClientCaptcha
                                chars="123456789"
                                captchaCode={val =>
                                  this.setState({
                                    captchaCode: val
                                  })
                                }
                                height="38"
                                containerClassName="captchaCodeContainer"
                                retryButtonClassName="retryCaptchaCodeButton"
                                retryIcon={refreshSvg}
                                retryIconSize="28"
                              // retry={false}
                              />
                            </div>
                            <ErrorMessage component={ErrorPopUp} name="captcha" />
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-5 text-center">
                            <button
                              type="submit"
                              style={{ width: 300 }}
                              className={
                                'btn btn-warning btn-md btn-block pull-right flex-btn' +
                                (loading ? ' isSubmitting' : '')
                              }
                              disabled={loading}>
                              {loading ? (
                                <AiOutlineLoading
                                  className="mdi-spin"
                                  size="22px"
                                />
                              ) : (
                                <AiOutlineSave size="22px" />
                              )}
                              <span>ارسال اطلاعات</span>
                            </button>
                            <br />
                            <br />
                            <br />
                          </div>
                        </div>
                      </form>
                    )
                  }}
                </Formik>
                <SweetAlert
                  show={this.state.showSweetAlert}
                  onConfirm={() => this.setState({ showSweetAlert: false })}
                  onCancel={() => this.setState({ showSweetAlert: false })}
                  closeOnClickOutside={false}
                  showCancel
                  type="success"
                  btnSize="sm"
                  customClass="swal2"
                  // confirmBtnCssClass="btn btn-success swal2-confirm"
                  cancelBtnCssClass="btn btn-danger swal2-cancel"
                  showConfirm={false}
                  cancelBtnText="بستن"
                  title="اطلاعات نمایندگی با موفقیت ثبت شد.">
                  {'کد پیگیری: ' + this.state.sellerFormCode}
                </SweetAlert>
              </Tab.Pane>
              {/*  },

               ]}
              className="customTabs" /> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SellerForm
